import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timeTrackingFieldName: {
		id: 'issue-create.common.fields.time-tracking-field.time-tracking-field-name',
		defaultMessage: 'Original Estimate',
		description: 'Label for time tracking field',
	},
});
